export default __webpack_public_path__ + "static/media/SMA17_Approved_Seal_web.e75bf029.png";